export default __webpack_public_path__ + "static/imgModalLogin-bd7fe9d1b4fc1140c6dd786c4f4e59a0.png";